import {
  garageStore,
} from './garage';

import {
  appointmentStore,
} from './appointment';

import {
  leasingCompanyStore,
} from './leasing-company';

import {
  cityStore,
} from './city';


// ============================================================================
// :: STORE MODULES
// ============================================================================

export const STORE_MODULES = {
  appointment: appointmentStore,
  garage: garageStore,
  leasingCompany: leasingCompanyStore,
  city: cityStore,
};
